module.exports = __webpack_public_path__ + "static/media/Cedric Diggory 3.e4082662.jpg";